<template>
  <div>
    <!-- 选择要加入的货盘-->
    <el-dialog :title="$t('message.selectInventoryToJoin')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="row">
        <el-select v-model="pallet_config_ids" placeholder="选择货盘" multiple style="width: 400px;">
          <el-option v-for="item in $parent.palletyOption" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确认 -->
        <el-button type="primary" @click="batchAddPallet">{{
          $t("message.notarize")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      pallet_config_ids: [],
      goodsIds: [],
    };
  },
  methods: {
    //新增货盘
    batchAddPallet() {
      let datas = {
        goodsIds: this.goodsIds,
        pallet_config_ids: this.pallet_config_ids
      }
      if (this.pallet_config_ids == false) return this.$message.error('请选择要加入的货盘')
      this.$api.siteConfiguration.batchAddPallet(datas).then(res => {
        this.$message.success(res.msg)
        this.$parent.rakuProductList()
        this.pallet_config_ids = []
        this.dialogVisible = false
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.add {
  margin-bottom: 24px;
  text-align: right;
}

.content {
  margin: 0px 15px;


  li {
    padding: 0 15px;
    flex: 1.5;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }
}

.row {
  display: flex;
  padding: 0 20px;

  .label {
    width: 100px;
    line-height: 40px;
  }

  .val {
    flex: 1;
  }
}
</style>